<template>
  <div class="enter-effect":style="{height: collapse ? '46px': ''}">
    <div class="enter-effect-header" @click="collapse = !collapse">
      <span>入场动画</span>
      <i class="icon icon-set-down" :style="{transform: collapse ? '' : 'rotate(180deg)'}"></i>
    </div>
    <div class="enter-effect-content">
      <div v-for="(item, key) in enterArr" v-if="item.show" :class="{'disable': item.disabled}">
        <el-tooltip
          effect="dark"
          placement="top"
          :disabled="!item.disabled"
          :content="special.artText ? tip2 : tip"
        >
          <div :class="{active: type === item.type, 'effect-select': true}" @click="setEffect($event, item, key)">
            <i class="is-short" :class="{[`icon-${item.alias}-anim`]: true}"></i>
          </div>
        </el-tooltip>
        <span class="effect-name">{{item.text}}</span>
      </div>
    </div>
    <div class="exit-effct-footer">
      <div class="radios" v-if="type === 'Slide'">
        <div class="radios__title">
          动画速度
        </div>
        <ul class="radios__list">
          <li
            class="radios__item"
            v-for="(item, key) in easingList"
            :class="{active: item.active}"
            :key="key"
            @click="setEasing(item)"
          >
            <i></i>
            <span>{{item.text}}</span>
          </li>
        </ul>
      </div>
      <div class="list" v-if="type==='Slide' || type === 'Smear'">
        <div class="list__title">
          动画方向
        </div>
        <ul class="list__items">
          <li
            class="list__item"
            :class="{active: item.active}"
            v-for="(item, index) in showList"
            :key="index"
            @click="selectEffect(item)"
          >
            <div class="list__figure" :class="{[`icon-wrapper-${item.icon || item.to}`]: true}">
              <i class="icon" :class="{[`icon-effect-${item.icon || item.to}`]: true}"></i>
            </div>
            <div class="list__caption">{{item.text}}</div>
          </li>
        </ul>
      </div>
      <div :class="['hand', {'disable': !hasHand}]" @click="showHand">
        <i class="icon-set-hand"></i>
        <span>添加入场手势</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    updateData: {
      type: Number,
      required: true,
      default: 0
    },
    enterArr: {
      type: Array,
      required: true,
      default: []
    },
    enterCode: {
      type: String,
      required: true,
      default: ''
    },
    special: {
      type: Object,
      required: true,
      default: {
        artText: false,
        stayEff: false
      }
    }
  },
  data() {
    return {
      collapse: false,
      type: '',
      easingList: [
        {type: 'easeIn', text: '加速', active: false, num: 1, alias: 'easeOutExpo'},
        {type: 'easeOut', text: '减速', active: false, num: 2, alias: 'easeOutQuint'},
        {type: 'linear', text: '匀速', active: false, num: 0, alias: 'linear'}
      ],
      showList: [],
      hasHand: false,
      tip: '该入场与停留特效不能并存，请调整试试吧',
      tip2: '该入场与动态艺术字不能并存，请调整试试吧',
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectSprites_Msg',
      'SelectScenes_Msg',
    ]),
  },
  watch: {
    'updateData'(val, oldVal) {
      this.initData();
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      if(this.enterCode === 'UpIn' || this.enterCode === 'RightIn' || this.enterCode === 'DownIn' || this.enterCode === 'LeftIn') {
        this.type = 'Slide';
      } else {
        this.type = this.enterCode;
      }
      let canHand = ['Slide', 'Hand', 'Draw', 'Write'];
      this.hasHand = canHand.indexOf(this.type) >= 0;
      let effect = this.SelectSprites_Msg[0].effect;
      this.initShowList(this.type, effect);
    },
    initShowList(type, effect) {
      if(type === 'Slide') {
        let easing = effect.easing;
        this.showList = [
          {text: '左移入', long: '从左移入', type: 'LeftIn', to: 'right', direction: '', active: false},
          {text: '右移入', long: '从右移入', type: 'RightIn', to: 'left', direction: '', active: false},
          {text: '上移入', long: '从上移入', type: 'UpIn', to: 'down', direction: '', active: false},
          {text: '下移入', long: '从下移入', type: 'DownIn', to: 'up', direction: '', active: false}
        ]
        this.easingList.forEach((item) => {
          if (item.alias === easing || item.num === easing) {
            item.active = true;
          } else {
            item.active = false;
          }
        })
        this.showList.forEach(item => {
          if(effect.code === item.type) {
            item.active = true;
          } else {
            item.active = false;
          }
        })
      } else if(type === 'Smear') {
        let enterDire = effect.direction;
        this.showList = [
          {text: '左擦入', long: '从左擦入', type: 'Smear', to: 'right', direction: 'e', active: false, icon: 'smear-e'},
          {text: '右擦入', long: '从右擦入', type: 'Smear', to: 'left', direction: 'w', active: false, icon: 'smear-w'},
          {text: '上擦入', long: '从上擦入', type: 'Smear', to: 'down', direction: 's', active: false, icon: 'smear-s'},
          {text: '下擦入', long: '从下擦入', type: 'Smear', to: 'up', direction: 'n', active: false, icon: 'smear-n'}
        ]
        this.showList.forEach((item) => {
          if (item.direction === enterDire) {
            item.active = true;
          } else {
            item.active = false;
          }
        })
      }
    },
    setEffect(e, item, key) {
      if(item.active || item.disabled) return;
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        data: [],
        reData: []
      }
      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        let {start, end} = s.effect.entranceAnim;
        undoData.reData.push({
          id: s.id,
          data: {
            code: s.effect.code,
            entranceAnim: {
              start: start,
              end: end
            }
          }
        })
        let code = item.type;
        if (code === 'Slide') {
          code = 'LeftIn'
        }
        if (code === 'None') {
          start = end;
        } else {
          start = Math.max(end - 500, 0);
        }

        undoData.data.push({
          id: s.id,
          data: {
            code: code,
            entranceAnim: {
              start,
              end
            }
          }
        })
        s.updateEffect({
          code: code,
          entranceAnim: {
            start,
            end
          }
        })
      }
      eve("undo_redo", null, {type: 'updateEffects', data: undoData})
      this.$emit('changeData')
    },
    setEasing(item) {
      if(item.active) return;
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        data: [],
        reData: []
      }
      this.easingList.forEach(v => {
            v.active = false;
      })
      item.active = true;
      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        undoData.reData.push({
          id: s.id,
          data: {
            easing: s.effect.easing,
          }
        })
        undoData.data.push({
          id: s.id,
          data: {
            easing: item.alias
          }
        })
        s.updateEffect({
          easing: item.alias
        })
      }
      eve("undo_redo", null, {type: 'updateEffects', data: undoData})
    },
    selectEffect(item) {
      if(item.active) return;
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        data: [],
        reData: []
      }
      this.showList.forEach(v => {
            v.active = false;
      })
      item.active = true;
      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        let data = {}
        undoData.reData.push({
          id: s.id,
          data: {
            code: s.effect.code,
            direction: s.effect.direction
          }
        })
        
        if(this.type === 'Slide') {
          data.code = item.type;
        } else {
          data.direction = item.direction;
        }

        undoData.data.push({
          id: s.id,
          data: data
        })

        s.updateEffect(data)
      }
      
      eve("undo_redo", null, {type: 'updateEffects', data: undoData})
    },
    showHand() {
      if(!this.hasHand) return;
      let name = this.type === 'Write' ? 'writehand' : 'hand';
      this.$bus.emit('Modal_vue', {
        name: name,
        type: name,
        data: {
          inout: 'in',
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.enter-effect {
  width: 100%;
  transition: all 0.3s;
  border-bottom: 1px solid #D4D4E7;
  overflow: hidden;
}
.enter-effect-header {
  display: flex;
  height: 46px;
  line-height: 46px;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: #474261;
  cursor: pointer;

  i {
    width: 10px;
    height: 6px;
    margin-right: 10px;
    transition: all 0.3s;
  }
}
.enter-effect-content{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  > div {
    text-align: center;
    font-size: 13px;
    margin-right: 12px;
    margin-bottom: 13px;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }

  .effect-select {
    margin: 0 auto;
    width: 46px;
    height: 46px;
    background-color: #f0f0f8;
    border-radius: 4px;
    margin-bottom: 7px;
    line-height: 60px;
    text-align: center;
    border: 2px solid transparent;
    cursor: pointer;
    overflow: hidden;
  }

  .effect-select.active {
    border-color: #5778fb;
  }

  .is-short {
    display: inline-block;
    width: 42px;
    height: 42px;
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .icon-noAnim-anim {
    position: relative;
    right: -50%;
    background: #FF293D;
    width: 2px;
    height: 102%;
    display: block;
    transform: skew(-45deg);
  }

  .disable {
    opacity: .5;

    .effect-select {
      cursor: not-allowed;

      &:hover {
        background-color: #f0f0f8;
      }
    }
  }
}

.radios {
  margin-bottom: 13px;

  &__title {
    color: #474261;
    margin-bottom: 13px;
    text-align-last: left;
  }

  &__list {
    display: flex;
    width: 180px;
    justify-content: space-between;
    align-items: center;
  }
  &__item {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;

    &>i {
      width: 16px;
      height: 16px;
      border-radius: 16px;
      border: solid 1px #9692a9;
    }
    &>span {
      padding-left: 5px;
    }

    &.active>i {
      background-color: #9692a9;
      box-shadow: 0 0 0 2px #ffffff inset;
    }
  }
}

.list {

  &__title {
    color: #474261;
    margin-bottom: 13px;
    text-align-last: left;
  }

  & > ul {
    display: flex;
  }
  &__items {
    justify-content: space-between;
  }
  &__item {
    margin-right: 6px;
    margin-bottom: 15px;
    cursor: pointer;

    &:nth-child(4n) {
      margin-right: 0;
    }

    &.active .list__figure {
      border-color: #5778fb;
      background-color: #D9DDEA;
    }
  }
  &__figure {
    width: 46px;
    height: 46px;
    background-color: #f0f0f8;
    border: 2px solid transparent;
    border-radius: 4px;
    overflow: hidden;
  }
  &__caption {
    margin-top: 7px;
  }
}

.list .list__item .list__figure >.icon {
  width: 44px;
  height: 44px;
}

.hand {
  margin-bottom: 15px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #D9DDEA;
  border-radius: 4px;
  cursor: pointer;

  &.disable {
    opacity: .6;
    cursor: not-allowed;
  }

  i {
    width: 14px;
    height: 14px;
    margin-right: 3px;
  }

  &:hover:not(.disable) {
    border-color: #5778FB;
  }
}

.icon-write-anim {
  background-image: url('../../../static/animengine/img/icon-effect-write.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-write.gif');
  }
}
.icon-appear-anim {
  background-image: url('../../../static/animengine/img/icon-effect-appear.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-appear.gif');
  }
}
.icon-type-anim {
  background-image: url('../../../static/animengine/img/icon-effect-type.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-type.gif');
  }
}
.icon-roll-anim {
  background-image: url('../../../static/animengine/img/icon-effect-roll.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-roll.gif');
  }
}
.icon-bounce-anim {
  background-image: url('../../../static/animengine/img/icon-effect-bounce.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-bounce.gif');
  }
}
.icon-slide-anim {
  background-image: url('../../../static/animengine/img/icon-effect-right.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-right.gif');
  }
}
.icon-pop-anim {
  background-image: url('../../../static/animengine/img/icon-effect-pop.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-pop.gif');
  }
}
.icon-fade-anim {
  background-image: url('../../../static/animengine/img/icon-effect-fade.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-fade.gif');
  }
}
.icon-smear-anim {
  background-image: url('../../../static/animengine/img/icon-effect-smear-e.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-smear-e.gif');
  }
}
.icon-hand-anim {
  background-image: url('../../../static/animengine/img/icon-effect-hand.png');

  &:hover {
    background-image: url('../../../static/animengine/img/icon-effect-hand.gif');
  }
}
</style>


// WEBPACK FOOTER //
// src/components/settingPanel/enterEffect.vue